<template>
  <el-menu class="navbar" mode="horizontal">
    <hamburger class="hamburger-container" :toggleClick="toggleSideBar" :isActive="sidebar.opened"></hamburger>
    <breadcrumb></breadcrumb>
    
    <!-- 通知下拉框 -->
    <el-dropdown class="notice-container" trigger="click" @visible-change="onNoticeVisibleChange">
      <div class="notice-wrapper">
        <i class="el-icon-bell notice-icon"></i>
        <span v-if="unreadCount > 0" class="notice-badge">{{ unreadCount }}</span>
      </div>
      <el-dropdown-menu slot="dropdown" class="notice-dropdown">
        <notice @updateUnreadCount="updateUnreadCount"></notice>
      </el-dropdown-menu>
    </el-dropdown>
    
    <el-dropdown class="avatar-container" trigger="click">
      <div class="avatar-wrapper">
        <img class="user-avatar" :src="avatar ? avatar : renderIcon" :title="name">
        <i class="el-icon-caret-bottom"></i>
      </div>
      <el-dropdown-menu class="user-dropdown" slot="dropdown">
        <router-link class="inlineBlock" to="/dashboard">
          <el-dropdown-item>
            首页
          </el-dropdown-item>
        </router-link>
        <router-link class="inlineBlock" to="/profile">
          <el-dropdown-item>
            个人信息
          </el-dropdown-item>
        </router-link>
        <el-dropdown-item divided>
          <span @click="logout" style="display:block;">退出</span>
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </el-menu>
</template>

<script>
import { mapGetters } from 'vuex'
import Breadcrumb from '@/components/Breadcrumb'
import Notice from '@/components/Notice'
import icon1 from '@/assets/images/png/icon-test_1.png'
import icon2 from '@/assets/images/png/icon-test_2.png'
import icon3 from '@/assets/images/png/icon-test_3.png'
import icon4 from '@/assets/images/png/icon-test_4.png'
import icon5 from '@/assets/images/png/icon-test_5.png'
import icon6 from '@/assets/images/png/icon-test_6.png'
import icon7 from '@/assets/images/png/icon-test_7.png'
import icon8 from '@/assets/images/png/icon-test_8.png'
import Hamburger from '@/components/Hamburger';
import { countUnread } from '@/api/notice';


export default {
  data() {
      return {
        currentIcon: '',
        unreadCount: 0,
        icon1,
        icon2,
        icon3,
        icon4,
        icon5,
        icon6,
        icon7,
        icon8
      }
  },
  components: {
    Breadcrumb,
    Hamburger,
    Notice
  },
  computed: {
    ...mapGetters([
      'sidebar',
      'avatar',
      'name'
    ]),
    renderIcon: function() {
      let randomList = [icon1, icon2, icon3, icon4, icon5, icon6, icon7, icon8];
      const randomNumber = Math.floor(Math.random() * 8);
      return randomList[randomNumber];
    }
  },
  created() {
    // countUnread().then(response => {
    //   if(response.data) {
    //     this.unreadCount = response.data;
    //   }
    // })
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch('ToggleSideBar')
    },
    logout() {
      this.$store.dispatch('LogOut').then(() => {
        location.reload() // 为了重新实例化vue-router对象 避免bug
      })
    },
    onNoticeVisibleChange(visible) {
      // 下拉框显示/隐藏时的回调
    },
    updateUnreadCount(value) {
      this.unreadCount = value
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.navbar {
  height: 50px;
  line-height: 50px;
  border-radius: 0px !important;
  .hamburger-container {
    line-height: 58px;
    height: 50px;
    float: left;
    padding: 0 10px;
  }
  .screenfull {
    position: absolute;
    right: 90px;
    top: 16px;
    color: red;
  }
  .notice-container {
    height: 50px;
    display: inline-block;
    position: absolute;
    right: 100px;
    line-height: 50px;
    .notice-wrapper {
      cursor: pointer;
      position: relative;
      display: flex;
      align-items: center;
      height: 50px;
      .notice-icon {
        font-size: 18px;
        color: #606266;
      }
      .notice-badge {
        position: absolute;
        top: 8px;
        right: -8px;
        background: #f56c6c;
        color: white;
        border-radius: 50%;
        width: 16px;
        height: 16px;
        font-size: 10px;
        text-align: center;
        line-height: 16px;
      }
    }
  }
  .avatar-container {
    height: 50px;
    display: inline-block;
    position: absolute;
    right: 35px;
    .avatar-wrapper {
      cursor: pointer;
      margin-top: 5px;
      position: relative;
      .user-avatar {
        width: 40px;
        height: 40px;
        border-radius: 10px;
      }
      .el-icon-caret-bottom {
        position: absolute;
        right: -20px;
        top: 25px;
        font-size: 12px;
      }
    }
  }
}
</style>

<style>
.notice-dropdown {
  padding: 0 !important;
}
.notice-dropdown .el-dropdown-menu {
  padding: 0 !important;
  margin: 0 !important;
}
</style>




// WEBPACK FOOTER //
// src/views/layout/components/Navbar.vue